module.exports = __webpack_public_path__ + "img/setting.c3b4bc33.svg";